export default "__VITE_ASSET__C4NunRAi__"